import { axios } from '../utils/request_new'

/* 查询推送记录 */
export function getDeviceRecord(data = { sn: '', page: 1, pagesize: 99999 }) {
  return axios({
    url: '/print/device-push-records/page',
    method: 'GET',
    params: data
  })
}

export default {
  getDeviceRecord
}